export const GOLD_PIPELINE_MIN = 1_000_000;
export const GOLD_WON_MIN = 300_000;
export const GOLD_DEMO_HOURS_MIN = 100;

export const getDemoHours = (totalSessionDuration) => parseInt(totalSessionDuration, 10) / 60;

export const isGoldChannel = (row, includeMetrics = true) => {
  if (!includeMetrics) return false;
  const pipeline = parseFloat(row.dollar_amount) || 0;
  const won = parseFloat(row.won_dollar_amount) || 0;
  const demoHours = getDemoHours(row.total_session_duration);
  return (
    pipeline > GOLD_PIPELINE_MIN &&
    won > GOLD_WON_MIN &&
    demoHours > GOLD_DEMO_HOURS_MIN
  );
};
